import { render, staticRenderFns } from "./edit-internal-doc.vue?vue&type=template&id=2cc6d711&scoped=true&"
import script from "./edit-internal-doc.vue?vue&type=script&lang=js&"
export * from "./edit-internal-doc.vue?vue&type=script&lang=js&"
import style0 from "./edit-internal-doc.vue?vue&type=style&index=0&id=2cc6d711&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc6d711",
  null
  
)

export default component.exports